import { z } from 'zod';

export const AggregateValueSchema = z.object({
    sum: z.number().optional(),
    count: z.number().optional(),
    groups: z
        .array(
            z.object({
                id: z.record(z.any()), // Using z.record for the dynamic object
                count: z.number().optional(),
                sum: z.number().optional(),
            }),
        )
        .optional(),
});

export type AggregateValue = { sum?: number; count?: number; groups?: { id: Record<string, any>; count?: number; sum?: number }[] };

export const QueryResultsSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
    z.object({
        count: z.number(),
        limit: z.number(),
        page: z.number(),
        aggregate: AggregateValueSchema.optional(),
        results: z.array(itemSchema),
    });

export class QueryResults<T> {
    count: number;
    limit: number;
    page: number;
    aggregate?: AggregateValue | undefined;
    results: T[];
}
